
export const REACT_APP_API_BASE_URL = 'https://admin.inrise.in/';
export const wsUrl = "admin.inrise.in"

export const REACT_APP_STRATEGY_ENGINE_URL = 'https://admin.inrise.in/strategy-api/';
// export const REACT_APP_API_BASE_URL = 'http://192.168.1.14:3002/'
// export const wsUrl = "192.168.1.14:3002";
